module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users-hours text-dark"
  }, [_c('div', {
    staticClass: "users-hours__header"
  }, [_c('h2', [_vm._v("Årsnormsopgørelse for " + _vm._s(_vm.numberOfWorkDaysInPeriod) + " arbejdsdage")]), _vm._v(" "), _c('div', {
    staticClass: "user-tasks__header__right"
  }, [(!_vm.isDatesPristine) ? _c('p', {
    staticClass: "d-link",
    on: {
      "click": _vm.resetDates
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('DatePickerRange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('setIsShowEmploymentEnded', true)
      }
    }
  }, [_vm._v("Brudt ansættelse")]), _vm._v(" "), _c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "isBottomStart": false,
      "propOffset": [5, 5]
    }
  }, [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "icon-more2"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('li', {
    on: {
      "click": _vm.updateUserHours
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.assign_users_hours.update')) + "\n          ")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "user-table-container"
  }, [(_vm.isLoadingUpdatedNumbers) ? _c('div', {
    staticClass: "user-table-container__loader",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('Loader', {
    attrs: {
      "is-small": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "user-table"
  }, [_c('thead', [_c('tr', [_c('thUser', {
    attrs: {
      "rowspan": "3",
      "sort-prop": "name",
      "title": _vm.$t('vue2.assign_users_hours.name'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "working-hours",
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.work_hours')))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('tr', [_c('thUser', {
    staticClass: "working-hours",
    attrs: {
      "sort-prop": "v_total_hours_assigned_in_period",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "working-hours",
    attrs: {
      "sort-prop": "v_total_hours_actual",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "working-hours",
    attrs: {
      "sort-prop": "v_total_hours_diff",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "with-kids-color",
    attrs: {
      "sort-prop": "v_with_kids_assigned_in_period",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "with-kids-color",
    attrs: {
      "sort-prop": "v_with_kids_actual",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "with-kids-color",
    attrs: {
      "sort-prop": "v_with_kids_diff",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "without-kids-color",
    attrs: {
      "sort-prop": "v_without_kids_assigned_in_period",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "without-kids-color",
    attrs: {
      "sort-prop": "v_without_kids_actual",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "without-kids-color",
    attrs: {
      "sort-prop": "v_without_kids_diff",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "working-hours",
    attrs: {
      "sort-prop": "v_with_and_without_kids_assigned_in_period",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "working-hours",
    attrs: {
      "sort-prop": "v_with_and_without_kids_actual",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('thUser', {
    staticClass: "working-hours",
    attrs: {
      "sort-prop": "v_with_and_without_kids_diff",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  })], 1)]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedUsers), function(user) {
    return _c('tr', {
      key: user.id,
      staticClass: "tr-user"
    }, [_c('th', {
      staticClass: "tr-user__name"
    }, [_c('div', {
      staticClass: "tr-user__name__inner"
    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
      staticClass: "tr-user__name__bttn icon__bg-circle hint--right",
      attrs: {
        "aria-label": "Årsnormsoversigt"
      },
      on: {
        "click": function($event) {
          return _vm.setTheActiveUserInAssignHours(user)
        }
      }
    }, [_c('svg', {
      staticClass: "icon-chart tw-icon tw-icon--small",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      staticClass: "primary",
      attrs: {
        "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "secondary",
      attrs: {
        "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
      }
    })])])])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return !_vm.isDatesPristine; }
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
      }],
      staticClass: "number td-presence",
      class: {
        'is-number--calculated': !_vm.isDatesPristine
      },
      attrs: {
        "content": _vm.createTooltip(user.v_assigned_total_hours)
      }
    }, [(!_vm.isDatesPristine) ? _c('span', {
      staticClass: "icon-clock"
    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_total_hours_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "number td-presence",
      attrs: {
        "aria-label": user.v_total_hours_actual
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "number td-presence number__scale-indicator",
      style: (_vm.scaleIndicator(user.v_total_hours_diff)),
      attrs: {
        "aria-label": user.v_total_hours_diff
      }
    }), _vm._v(" "), _c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return !_vm.isDatesPristine; }
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
      }],
      staticClass: "number with-kids-color",
      class: {
        'is-number--calculated': !_vm.isDatesPristine
      },
      attrs: {
        "content": _vm.createTooltip(user.v_total_with_kids)
      }
    }, [(!_vm.isDatesPristine) ? _c('span', {
      staticClass: "icon-clock"
    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_with_kids_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "number with-kids-color",
      attrs: {
        "aria-label": user.v_with_kids_actual
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "number with-kids-color number__scale-indicator",
      style: (_vm.scaleIndicator(user.v_with_kids_diff)),
      attrs: {
        "aria-label": user.v_with_kids_diff
      }
    }), _vm._v(" "), _c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return !_vm.isDatesPristine; }
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
      }],
      staticClass: "number without-kids-color",
      class: {
        'is-number--calculated': !_vm.isDatesPristine
      },
      attrs: {
        "content": _vm.createTooltip(user.v_total_without_kids)
      }
    }, [(!_vm.isDatesPristine) ? _c('span', {
      staticClass: "icon-clock"
    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_without_kids_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "number without-kids-color",
      attrs: {
        "aria-label": user.v_without_kids_actual
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "number without-kids-color number__scale-indicator",
      style: (_vm.scaleIndicator(user.v_without_kids_diff)),
      attrs: {
        "aria-label": user.v_without_kids_diff
      }
    }), _vm._v(" "), _c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return !_vm.isDatesPristine; }
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
      }],
      staticClass: "number td-presence",
      class: {
        'is-number--calculated': !_vm.isDatesPristine
      },
      attrs: {
        "content": _vm.createTooltip(user.v_assigned_total_hours)
      }
    }, [(!_vm.isDatesPristine) ? _c('span', {
      staticClass: "icon-clock"
    }) : _vm._e(), _vm._v("\n          " + _vm._s(user.v_total_hours_assigned_in_period) + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "number td-presence",
      attrs: {
        "aria-label": user.v_with_and_without_kids_actual
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "number td-presence number__scale-indicator",
      style: (_vm.scaleIndicator(user.v_with_and_without_kids_diff)),
      attrs: {
        "aria-label": user.v_with_and_without_kids_diff
      }
    })])
  }), 0)])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    },
    on: {
      "close": _vm.closeTheUserToShowTasks
    }
  }, [_c('div', {
    staticClass: "user-task__container",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "user-task__container__header"
  }, [_c('h2'), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": _vm.closeTheUserToShowTasks
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('UserTasks', {
    attrs: {
      "initialStartDate": _vm.startDate,
      "initialEndDate": _vm.endDate,
      "user_id": _vm.theUserToShowTasks.id,
      "user_calendar_id": _vm.theUserToShowTasks.user_calendar_id,
      "user_name": _vm.theUserToShowTasks.name,
      "isShowPrintButton": false,
      "isCanSeeOtherUsers": false
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "with-kids-color",
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', [_vm._v("Med børn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "without-kids-color",
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', [_vm._v("Uden børn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "working-hours",
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', [_vm._v("Med + uden børn")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07078da5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnnualNorm/AnnualNormResult.vue
// module id = 1441
// module chunks = 1